import React, { useState } from "react"
import { Button, Modal, OverlayTrigger, Table, Tooltip } from "react-bootstrap"
import { injectIntl } from "react-intl"
import LoadingSpinner from "../../common/spinner/loading.component"
import { Intl } from "../../state/helpers/IntlProps"
import PaymentProcessorService from "../../state/payment-processor/paymentProcessorService"
import Terminal from "../../state/terminal/Terminal"
import TerminalService from "../../state/terminal/TerminalService"
import TerminalBadges from "../components/TerminalBadges"
import TestModeAlert from "../components/TestModeAlert"
import { messages as modalMessages } from "./TerminalMessages"
import "./modals.scss"

type Props = {
    intl: Intl,
    show: boolean,
    terminal: Terminal,
    onClose: (success: boolean) => void,
}

const TerminalDetailsModal = (props: Props) => {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const [showConfirmDelete, setShowConfirmDelete] = useState<boolean>(false)

    const handleClose = (success = false) => {
        setIsLoading(false)
        setShowConfirmDelete(false)
        props.onClose(success)
    }

    const handleDelete = async () => {
        setIsLoading(true)
        setShowConfirmDelete(false)
        const res = await TerminalService.delete(props.terminal.getId())
        setIsLoading(false)

        if (res.isLoaded()) {
            handleClose(true)
        }
    }

    const handleResetTerminal = async () => {
        setIsLoading(true)
        await PaymentProcessorService.cancelPayin(props.terminal.getId())
        await TerminalService.update(props.terminal.getId(), false)
        setIsLoading(true)
        handleClose(true)
    }

    return (
        <Modal size="lg" show={props.show} onHide={props.onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    {props.intl.formatMessage(modalMessages.detailsModalHeader)}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <TestModeAlert />
                <Table className="rounded" bordered>
                    <tbody>
                        <tr>
                            <td className="bg-light"><strong>{props.intl.formatMessage(modalMessages.deviceNameHeader)}</strong></td>
                            <td>{props.terminal.getName()}</td>
                        </tr>
                        <tr>
                            <td className="bg-light"><strong>{props.intl.formatMessage(modalMessages.brandAndModelHeader)}</strong></td>
                            <td>{props.terminal.getBrandAndModel()}</td>
                        </tr>
                        <tr>
                            <td className="bg-light"><strong>{props.intl.formatMessage(modalMessages.statusHeader)}</strong></td>
                            <td>
                                <TerminalBadges terminal={props.terminal} />
                            </td>
                        </tr>
                        <tr>
                            <td className="bg-light"><strong>{props.intl.formatMessage(modalMessages.pairedDateHeader)}</strong></td>
                            <td>{props.terminal.getCreatedAt()}</td>
                        </tr>
                        <tr>
                            <td className="bg-light"><strong>{props.intl.formatMessage(modalMessages.terminalIdHeader)}</strong></td>
                            <td>{props.terminal.getId()}</td>
                        </tr>
                        <tr>
                            <td className="bg-light"><strong>{props.intl.formatMessage(modalMessages.deviceRegistrationIdHeader)}</strong></td>
                            <td>{props.terminal.getExternalId()}</td>
                        </tr>
                        <tr>
                            <td className="bg-light"><strong>{props.intl.formatMessage(modalMessages.serialNumberHeader)}</strong></td>
                            <td>{props.terminal.getSerialNumber()}</td>
                        </tr>
                        <tr>
                            <td className="bg-light"><strong>{props.intl.formatMessage(modalMessages.paymentAccountHeader)}</strong></td>
                            <td>{props.terminal.getPaymentAccountId()}</td>
                        </tr>
                    </tbody>
                </Table>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-between">
                <div>
                    {!showConfirmDelete && (
                        <Button variant="danger" onClick={() => setShowConfirmDelete(true)} disabled={isLoading}>
                            {isLoading && <LoadingSpinner height={18} />}
                            {!isLoading && <span>{props.intl.formatMessage(modalMessages.detailsModalDeleteBtn)}</span>}
                        </Button>
                    )}
                    {showConfirmDelete && (
                        <div className="d-flex align-items-center">
                            <span>{props.intl.formatMessage(modalMessages.detailsModalConfirmDelete)}</span>
                            <Button className="mr-2 ml-2" variant="danger" onClick={handleDelete} disabled={isLoading}>
                                <span>{props.intl.formatMessage(modalMessages.detailsModalConfirmDeleteBtn)}</span>
                            </Button>
                            <Button variant="secondary" onClick={() => setShowConfirmDelete(false)} disabled={isLoading}>
                                <span>{props.intl.formatMessage(modalMessages.detailsModalCancelDeleteBtn)}</span>
                            </Button>
                        </div>
                    )}
                </div>
                <div>
                    <OverlayTrigger
                        placement="top"
                        overlay={
                            <Tooltip id="button-tooltip">
                                {props.intl.formatMessage(modalMessages.detailsModalResetTooltip)}
                            </Tooltip>
                        }
                        trigger="hover"
                    >
                        <Button className="mr-2" variant="danger" onClick={() => handleResetTerminal()} disabled={isLoading}>
                            {isLoading && <LoadingSpinner height={18} />}
                            {!isLoading && <span>{props.intl.formatMessage(modalMessages.detailsModalResetBtn)}</span>}
                        </Button>
                    </OverlayTrigger>
                    <Button variant="secondary" onClick={() => handleClose()} disabled={isLoading}>
                        {isLoading && <LoadingSpinner height={18} />}
                        {!isLoading && <span>{props.intl.formatMessage(modalMessages.detailsModalCloseBtn)}</span>}
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    )
}

export default injectIntl(TerminalDetailsModal)


// WEBPACK FOOTER //
// ./src/payment-processing/modals/TerminalDetailsModal.tsx